import React, {useEffect, useState} from "react";
import BlockButton from "../components/block-button";
import {useTranslation} from "react-i18next";
declare var DataActivationController: any;
type FormData = {
    carrierPostData: string;
    eid: string;
    iccid: string;
    displayName: string;
    deviceImei: string;
    deviceMeid: string;
    deviceType: string;
    primaryDeviceIccid: string;
};

const ManageAccount = () => {
    const {t} = useTranslation();
    const [watchInfo, setWatchInfo] = useState({} as FormData);

    useEffect(() => {
        const watchInfoText = localStorage.getItem('watchInfo');
        if (watchInfoText) {
            try {
                const watchInfoJson = JSON.parse(watchInfoText);
                setWatchInfo(watchInfoJson)
            } catch (error) {
                console.error('Error parsing JSON:', error);
            }
        } else {
            console.log('No watchInfo found in localStorage.');
        }
    }, []);

    const onCancel = () => {
        const dataActivationController = DataActivationController;
        // @ts-ignore
        if (DataActivationController) {
            // @ts-ignore
            dataActivationController.doneSelected();
        } else {
            console.error("DataActivationController not found");
        }
    };


    return (<div className="layout-default">
        <h2 className="layout-default-left watch-title">{t("accountManagementTitle")}</h2>

        <h3 data-testid='displayName' className="layout-default-left">{(localStorage?.getItem('displayName') || watchInfo?.displayName) || ''}</h3>
        <div className="layout-default-left">
            <span data-testid='iccid'>ICCID: {(localStorage?.getItem('primaryDeviceIccid') || watchInfo?.iccid) || ''}</span>
            <span data-testid='imei'>{t("imeiText")}: {(localStorage?.getItem('deviceImei') || watchInfo?.deviceImei) || ''}</span>
        </div>
        <h3 className="layout-default-left">{t("update911AddressText")}</h3>
        <div className="layout-default-left">
            <span dangerouslySetInnerHTML={{__html: t("line1")}}></span>
            <span dangerouslySetInnerHTML={{__html: t("line2")}}></span>
            <span dangerouslySetInnerHTML={{__html: t("line3")}}></span>
        </div>
        <h3 className="layout-default-left">{t("cancelTitle")}</h3>
        <p>{t("cancelText")}</p>

        <BlockButton
            dataTestId="closeButton"
            text={t("closeText")}
            onClick={onCancel}
        />
    </div>);
}

export default ManageAccount;
